<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            .form__field(v-if="gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_view') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='viewTypes',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='type',
                        label='name',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseGameWithTime')",
                        v-model='viewType',
                        @select='params.viewType = $event.type'
                    )
            .form__field(v-if="gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='gameModes',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='mode',
                        label='name',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseGameWithTime')",
                        v-model='selectedGameMode',
                        @select='params.mode = $event.mode'
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ groupsString }}
                .form__field-body
                    cs-multiselect(
                        :options="groups"
                        :show-labels="false"
                        :hide-selected="true"
                        :max="null"
                        :close-on-select="false"
                        :clear-on-select="false"
                        placeholder=""
                        :multiple="true"
                        v-model="params.selectedGroups"
                        :disabled="groups.length === 0"
                        v-validate="'required'"
                        data-vv-value-path="innerValue"
                        data-vv-name="groups"
                        :data-vv-as="groups"
                        class="multiple-multiselect"
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_selectAllGroups') }}
                .form__field-body
                    cs-checkbox(
                        :checked='groups.length === params.selectedGroups.length',
                        @change="toggleGroups"
                    )
            .form__field(v-if="showWordConstitutingLettersFields")
                label.form__label
                    | {{ $i18n.tc('trainer.trainer_gameFormSetting_letters', 1) }}
                .form__field-body
                    cs-multiselect(
                        :options="letters"
                        :show-labels="false"
                        :hide-selected="true"
                        :max="null"
                        :close-on-select="false"
                        :clear-on-select="false"
                        placeholder=""
                        :multiple="true"
                        v-model="params.wordConstitutingLetters"
                        :disabled="letters.length === 0"
                        v-validate="'required'"
                        data-vv-value-path="innerValue"
                        data-vv-name="letters"
                        :data-vv-as="letters"
                        class="multiple-multiselect"
                    )
            .form__field(v-if="showWordConstitutingLettersFields")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_selectAllLetters') }}
                .form__field-body
                    cs-checkbox(
                        :checked='wordConstitutingLettersLength === letters.length',
                        @change="toggleWordConstitutingLetters"
                    )
            div(
                v-if="selectedSyllableGroupsWithTwoLetters && slug === 'CatchWordOnline'"
                v-for="(group, index) in selectedSyllableGroupsWithTwoLetters"
                :key="index"
            )
                .form__field(v-if="params.mode !== 'text' && gameMode !== 'course' && gameMode !== 'generator-settings' && selectedSyllableGroupsWithTwoLetters")
                    label.form__label
                        | {{ group.name }}
                    .form__field-body
                        cs-multiselect(
                            :options="group.letters"
                            :show-labels="false"
                            :hide-selected="true"
                            :max="null"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :multiple="true"
                            placeholder=""
                            v-model="params[group.name]"
                            v-validate="'required'"
                            data-vv-value-path="innerValue"
                            data-vv-name="groups"
                            :data-vv-as="$i18n.t('homework.homework_create_studentsVvSs')"
                        )
                .form__field(v-if="selectedSyllableGroupsWithTwoLetters")
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_selectAllLetters') }}
                    .form__field-body
                        cs-checkbox(
                            :checked='checkedValue(group.name)',
                            @change="selectAllLettersForGroup(group.name)"
                        )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_showTime') }}
                .form__field-body
                    cs-multiselect(
                        :options="seconds"
                        v-model="params.showTime"
                        :placeholder="secondsLabel(params.showTime)"
                        :custom-label="secondsLabel"
                        :multiple="false"
                        :allow-empty="false"
                    )
            .form__field(v-if="selectedGameMode && selectedGameMode.mode === 'interactive' && gameMode !== 'course' && gameMode !== 'generator-settings' && viewType")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_showInSeries', {element: $i18n.t('trainer.trainer_gameFormSettingValue_' + viewType.type)}) }}
                .form__field-body
                    cs-checkbox(v-model='params.isSeries')
            .form__field(v-if="params && params.isSeries && selectedGameMode.mode === 'interactive' && gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfSeries') }}
                .form__field-body
                    cs-spin-input(
                        :value="params.seriesAmount",
                        :max="series",
                        :min="1",
                        @increase="increaseSeriesAmount",
                        @decrease="decreaseSeriesAmount",
                        @input="params.seriesAmount = $event",
                    )
            .form__field(v-if="params && gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ amountOfItemsString }}
                .form__field-body
                    cs-spin-input(
                        :value="params.amountOfWords",
                        :max="words",
                        :min="3",
                        @increase="increaseAmountOfWords",
                        @decrease="decreaseAmountOfWords",
                        @input="params.amountOfWords = $event",
                    )
            .form__field(v-if="selectedGameMode && selectedGameMode.mode === 'static' && gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('olympiads.olympiads_olympiadForm_timeForAnswer') }}
                .form__field-body
                    cs-multiselect(
                        :options="seconds"
                        v-model="params.timeForAnswer"
                        :placeholder="secondsLabel(params.timeForAnswer)"
                        :custom-label="secondsLabel"
                        :multiple="false"
                        :allow-empty="false"
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings' && viewType")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_movement', {element: $i18n.t('trainer.trainer_gameFormSettingValue_' + viewType.type)}) }}
                .form__field-body
                    cs-checkbox(v-model='params.wordsMovement')
            .form__field
                label.form__label
                    | {{ invertedString }}
                .form__field-body
                    cs-checkbox(v-model='params.invertedWords')
            .form__field(v-if="params.viewType === 'words' && gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_accentedWords') }}
                .form__field-body
                    cs-checkbox(v-model='params.accentedWords')
            divider
            slot(name='parameters')
            slot(name='help')
            .form__buttons
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if='usersIds')
                    cs-button.form__button(v-if="usersIds" color="blue", @click='handleSaveGameMethod(saveGame)' :disabled="isSaveButtonDisabled")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
                template(v-else-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='handleSaveGameMethod(saveGameMode)' :disabled="isSaveButtonDisabled")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else)
                    cs-button.form__button(color="blue", @click='handleSaveGameMethod(saveGame)' :disabled="isSaveButtonDisabled")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
</template>

<script>
    /*eslint-disable*/
    import GameFormMixin from "../../../utils/trainer/GameFormMixin";
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from "../../../utils/trainer/getInitParameters";
    import { mapState } from 'vuex';
    import { cloneDeep, clone } from "lodash";
    import multiplayerFormMixin from "../../../utils/multiplayer/formMixin";
    import checkIfEnoughWordsBeforeSave from "../../../utils/trainer/checkIfEnoughWordsBeforeSave";
    import CatchWordReadingEnApi from '../../../api/games/catchWordReadingEn'
    import IntervalConfig from "../../trainer/configs/IntervalConfig";
    import availableAlphabets from '../../../config/availableAlphabets.js';

    const AVAILABLE_LANGUAGES = ['ru', 'uk'];

    export default {
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex'
        ],
        mixins: [GameFormMixin, multiplayerFormMixin],
        mounted () {
            this.getGroups();
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(this, 'params', getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: cloneDeep(this.gamesParameters[this.slug])
                        }
                    }));
                } else {
                    this.params = cloneDeep(TrainerGames.games).find(item => item.slug === this.slug).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            if (this.prevRoute) {
                this.gameModes = !this.prevRoute.name?.match('olympiad-level') ? this.gameModes : this.gameModes.filter(item => item.mode !== 'static');
            }
            this.selectedGameMode = this.gameModes.find(item => item.mode === this.params.mode);
            this.viewType = this.viewTypes.find(item => item.type === this.params.viewType);
            if (!this.params['Группа 1 (ма, ро)'] && this.params['группа1МаРо']) {
                this.$set(this.params, 'Группа 1 (ма, ро)', cloneDeep(this.params['группа1МаРо']));
            }
            if (!this.params['Группа 2 (мя, ки)'] && this.params['группа2МяКи']) {
                this.$set(this.params, 'Группа 2 (мя, ки)', cloneDeep(this.params['группа2МяКи']));
            }
            if (!this.params['Группа 3 (ам, ор)'] && this.params['группа3АмОр']) {
                this.$set(this.params, 'Группа 3 (ам, ор)', cloneDeep(this.params['группа3АмОр']));
            }
            if (!this.params['Группа 4 (ям, ер)'] && this.params['группа4ЯмЕр']) {
                this.$set(this.params, 'Группа 4 (ям, ер)', cloneDeep(this.params['группа4ЯмЕр']));
            }
        },
        updated () {
            this.params && (this.selectedGameMode = this.gameModes.find(item => item.mode === this.params.mode));
            this.params && (this.viewType = this.viewTypes.find(item => item.type === this.params.viewType));
        },
        data () {
            return {
                selectedGameMode: null,
                viewType: null,
                params: null,
                gameModes: [
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_static'),
                        mode: 'static'
                    },
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_interactive'),
                        mode: 'interactive'
                    },
                ],
                viewTypes: [
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSetting_words'),
                        type: 'words'
                    },
                    {
                        name: this.$i18n.tc('trainer.trainer_gameFormSetting_letters', 1),
                        type: 'letters'
                    }
                ],
                series: 20,
                words: 100,
                syllableGroups: [],
                wordGroups: [],
                alphabets: availableAlphabets,
                seconds: IntervalConfig.seconds,
                groupOne: ['А', 'О', 'У', 'Ы', 'Э', 'б', 'в', 'г', 'д', 'ж', 'з', 'к', 'л', 'м', 'н', 'п', 'р', 'с', 'т', 'ф', 'х', 'ц', 'ч', 'ш', 'щ'],
                groupTwo: ['Я', 'Ё', 'Ю', 'И', 'Е', 'б', 'в', 'г', 'д', 'ж', 'з', 'к', 'л', 'м', 'н', 'п', 'р', 'с', 'т', 'ф', 'х', 'ц', 'ч', 'ш', 'щ'],
                groupThree: ['А', 'О', 'У', 'Ы', 'Э', 'б', 'в', 'г', 'д', 'ж', 'з', 'к', 'л', 'м', 'н', 'п', 'р', 'с', 'т', 'ф', 'х', 'ц', 'ч', 'ш', 'щ'],
                groupFour: ['Я', 'Ё', 'Ю', 'И', 'Е', 'б', 'в', 'г', 'д', 'ж', 'з', 'к', 'л', 'м', 'н', 'п', 'р', 'с', 'т', 'ф', 'х', 'ц', 'ч', 'ш', 'щ'],
            }
        },
        methods: {
            getGroups() {
                CatchWordReadingEnApi.getGroups(this.user.locale).then(data => {
                    this.syllableGroups = data.syllableGroups;
                    this.wordGroups = data.wordGroups;
                });
            },
            selectAllLettersForGroup(val) {
                if(!this.params[val] || this.params[val].length < this.groupOne.length) {
                    if (val === 'Группа 1 (ма, ро)') {
                        this.$set(this.params, val, this.groupOne)
                    }
                    if (val === 'Группа 2 (мя, ки)') {
                        this.$set(this.params, val, this.groupTwo)
                    }
                    if (val === 'Группа 3 (ам, ор)') {
                        this.$set(this.params, val, this.groupThree)
                    }
                    if (val === 'Группа 4 (ям, ер)') {
                        this.$set(this.params, val, this.groupFour)
                    }
                } else {
                    this.params[val] = null;
                }
            },
            toggleWordConstitutingLetters() {
                if (this.params.wordConstitutingLetters.length < this.letters.length) {
                    this.params.wordConstitutingLetters = clone(this.letters);
                } else {
                    this.params.wordConstitutingLetters = [];
                }
            },
            toggleGroups() {
                if (this.params.selectedGroups.length < this.groups.length) {
                    this.selectAllGroupsForView(this.params.viewType);
                } else {
                    this.removeAllGroupsForView();
                    this.params.wordConstitutingLetters = clone(this.letters);
                }
            },
            checkedValue(groupName) {
                if (this.params[groupName]) {
                    return this.params[groupName].length === this.groupOne.length;
                }
            },
            checkSelectedGroups() {
                if (this.slug === 'CatchWordOnline') {
                    if (this.params['Группа 1 (ма, ро)'] && this.params['Группа 1 (ма, ро)'].length < 1 && !this.params.selectedGroups.find(item => item.includes('Группа 1 (ма, ро)'))
                            || !this.params['Группа 1 (ма, ро)'] && this.params.selectedGroups.find(item => item.includes('Группа 1 (ма, ро)'))) {
                        return true
                    } else if (this.params['Группа 2 (мя, ки)'] && this.params['Группа 2 (мя, ки)'].length < 1 && !this.params.selectedGroups.find(item => item.includes('Группа 2 (мя, ки)'))
                            || !this.params['Группа 2 (мя, ки)'] && this.params.selectedGroups.find(item => item.includes('Группа 2 (мя, ки)'))) {
                        return true
                    } else if (this.params['Группа 3 (ам, ор)'] && this.params['Группа 3 (ам, ор)'].length < 1 && !this.params.selectedGroups.find(item => item.includes('Группа 3 (ам, ор)'))
                            || !this.params['Группа 3 (ам, ор)'] && this.params.selectedGroups.find(item => item.includes('Группа 3 (ам, ор)'))) {
                        return true
                    } else if (this.params['Группа 4 (ям, ер)'] && this.params['Группа 4 (ям, ер)'].length < 1 && !this.params.selectedGroups.find(item => item.includes('Группа 4 (ям, ер)'))
                            || !this.params['Группа 4 (ям, ер)'] && this.params.selectedGroups.find(item => item.includes('Группа 4 (ям, ер)'))) {
                        return true
                    }
                }
                return false
            },
            secondsLabel (second) {
                return second + " " + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds')
            },
            decreaseSeriesAmount() {
                if (this.params.seriesAmount !== 1) {
                    this.params.seriesAmount -= 1;
                }
            },
            increaseSeriesAmount() {
                if (this.params.seriesAmount !== this.series) {
                    this.params.seriesAmount += 1;
                }
            },
            decreaseAmountOfWords() {
                if (this.params.amountOfWords !== 1) {
                    this.params.amountOfWords -= 1;
                }
            },
            increaseAmountOfWords() {
                if (this.params.amountOfWords !== this.words) {
                    this.params.amountOfWords += 1;
                }
            },
            checkedSelectedGroups (type) {
                switch (type) {
                    case 'words':
                        return this.params.selectedGroups.length === this.wordGroups.length;
                    case 'syllables':
                        return this.params.selectedGroups.length === this.syllableGroups.length;
                    case 'letters':
                        return this.params.selectedGroups.length === this.letters.length;
                }
            },
            selectAllGroupsForView(type) {
                switch (type) {
                    case 'words':
                        this.params.selectedGroups = cloneDeep(this.wordGroups);
                        break;
                    case 'syllables':
                        this.params.selectedGroups = cloneDeep(this.syllableGroups);
                        break;
                    case 'letters':
                        this.params.selectedGroups = cloneDeep(this.letters);
                        break;
                }
            },
            removeAllGroupsForView() {
                this.params.selectedGroups = [];
            },
            checkIfEnoughWords() {
                return CatchWordReadingEnApi.checkIfEnoughWords({
                    locale: this.user.locale,
                    type: this.params.viewType,
                    groups: this.params.selectedGroups,
                    amountOfWords: this.params.amountOfWords,
                    groupsLetters: this.params.lettersForGroups,
                })
                .then(data => {
                    return data.isEnoughWords;
                });
            },
            ...checkIfEnoughWordsBeforeSave
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user
            }),
            wordConstitutingLettersLength() {
                return this.params.wordConstitutingLetters?.length;
            },
            letters () {
                return this.alphabets.en;
            },
            groups () {
                switch (this.params?.viewType) {
                    case ('words'):
                        return this.wordGroups;
                    case ('letters'):
                        return this.letters;
                }
            },
            amountOfItemsString () {
                switch (this.params.viewType) {
                    case ('words'):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_amountOfWords');
                    case ('letters'):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_amountOfLetters');
                }
            },
            groupsString () {
                return this.params.viewType !== 'letters'
                        ? this.$i18n.t('trainer.trainer_gameFormSetting_groups')
                        : this.$i18n.tc('trainer.trainer_gameFormSetting_letters', 1)
            },
            invertedString () {
                switch (this.params.viewType) {
                    case ('words'):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_invertedWords');
                    case ('letters'):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_invertedLetters');
                }
            },
            isSaveButtonDisabled() {
                return this.params
                        && this.params.selectedGroups.length < 1
                        || (this.checkSelectedGroups() && this.courseType !== 'fastReading');
            },
            selectedSyllableGroupsWithTwoLetters() {
                let currentArray = [];
                let newObject = {};
                currentArray = this.params.selectedGroups.filter(group => group.length > 14);
                for (let i = 0; i < currentArray.length; i++) {
                    if (currentArray[i].includes('Группа 1 ')) {
                        newObject[i] = {
                            name: 'Группа 1 (ма, ро)',
                            letters: this.groupOne
                        }
                    } else if (currentArray[i].includes('Группа 2 ')) {
                        newObject[i] = {
                            name: 'Группа 2 (мя, ки)',
                            letters: this.groupTwo
                        }
                    } else if (currentArray[i].includes('Группа 3 ')) {
                        newObject[i] = {
                            name: 'Группа 3 (ам, ор)',
                            letters: this.groupThree
                        }
                    } else if (currentArray[i].includes('Группа 4 ')) {
                        newObject[i] = {
                            name: 'Группа 4 (ям, ер)',
                            letters: this.groupFour
                        }
                    }
                }
                return newObject;
            },
            showWordConstitutingLettersFields() {
                return this.viewType && this.viewType.type === 'words' && this.checkedSelectedGroups('words')
                    && this.slug === 'CatchWordOnline';
            }
        },
        watch: {
            'params.viewType': {
                handler (prevVal, newVal) {
                    prevVal !== newVal && !!newVal && (this.params.selectedGroups = []);
                }
            },
            'params.selectedGroups'(val) {
                if (val.length !== 0 && this.groups.length !== 0 && val.length !== this.groups.length) {
                    this.params.wordConstitutingLetters = clone(this.letters);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px;
        @include media($sm) {
            align-self: center;
            width: 250px;
        }
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>

